import React from "react"

import { NO, YES } from "const"
import { MtPackage } from "server/models"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"
import TableSelect from "../components/select"

const Study = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "studyModuleAccess",
            header: lang.studyModuleAccess,
            formatter: (packg: MtPackage) => {
                const { studyModuleAccess } = packg.settingsParsed
                return lang[studyModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { studyModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[studyModuleAccess]}
                        label={lang.studyModuleAccess}
                        property={{ studyModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Study
